<template>
    <div id="app">
        <v-app id="inspire">
            <v-row justify="center">
                <v-dialog v-model="dialog" persistent max-width="290">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn color="primary" dark v-bind="attrs" v-on="on">
                            Open Dialog
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title class="headline">
                            Use Google's location service?
                        </v-card-title>
                        <v-card-text>Let Google help apps determine location. This means sending anonymous location data
                            to Google, even when no apps are running.</v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="green darken-1" text @click="dialog = false">
                                Disagree
                            </v-btn>
                            <v-btn color="green darken-1" text @click="dialog = false">
                                Agree
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </v-app>
    </div>
</template>
<script>
    export default {
        name: "test",
        data() {
            return {
                dialog: false
            }
        }
    };
</script>
<style scoped>
    .serviceTitle {
        color: #2c3e50;
        font-weight: 500;
        line-height: 1.5;
        font-size: 22px;
        margin-top: 20px;
    }

    .listTitle {
        color: #2c3e50;
        font-weight: 500;
        line-height: 1.5;
        font-size: 18px;
        text-align: left;
    }

    .listDesc {
        text-align: justify;
        line-height: 1.5;
        font-size: 16px;
        color: #2c3e50;
        margin-top: 10px;
    }
</style>